import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SourceEnum } from '../../../../shared/store/typeahead/types';
import { ContractService } from '../../../../shared/store/contract/contract.service';
import { ContractTerminationReasonModel } from '../../../../shared/store/contract/types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubHeaderService } from '../../../../shared/store/subheader/subheader.service';
import { FormService } from '../../../../shared/store/form/form.service';
import { MAX_DATE_MASK_SAFE_GUARD } from '../../../../shared/constants/date.constants';
import {
  ModalComponent,
  ModalComponentKey,
} from 'src/app/shared/service/modal-component';

@UntilDestroy()
@ModalComponent(ModalComponentKey.ContractTerminationReason)
@Component({
  selector: 'app-contract-termination-reason-content',
  templateUrl: './contract-termination-reason-content.component.html',
  styleUrls: ['./contract-termination-reason-content.component.scss'],
  standalone: false,
})
export class ContractTerminationReasonContentComponent implements OnInit {
  @Input() modalRandomIdentifier: number;
  @Input() contractId: number;
  @Input() source: SourceEnum = SourceEnum.Component;

  contractTerminationReasonForm: FormGroup;
  maxDateMaskSafeGuard: string = MAX_DATE_MASK_SAFE_GUARD;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly contractService: ContractService,
    private readonly activeModalService: NgbActiveModal,
    private readonly subHeaderService: SubHeaderService,
    private readonly formService: FormService,
  ) {}

  ngOnInit(): void {
    this.contractTerminationReasonForm = this.formBuilder.group({
      terminationReasonId: [undefined, Validators.required],
      terminationDate: [undefined, Validators.required],
    });

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'closeContract') this.onSubmit();

        this.subHeaderService.setTriggerAction('');
      });
  }

  onSubmit() {
    if (this.contractTerminationReasonForm.invalid) {
      this.contractTerminationReasonForm.markAllAsTouched();
      this.formService.countErrors(this.contractTerminationReasonForm, true);
      return;
    }

    const contractTerminationReasonModel: ContractTerminationReasonModel = {
      contractId: this.contractId,
      terminationReasonId: this.contractTerminationReasonForm.get(
        'terminationReasonId',
      )?.value,
      terminationDate:
        this.contractTerminationReasonForm.get('terminationDate')?.value,
    };

    this.contractService.closeContract.call(contractTerminationReasonModel);

    this.activeModalService.close();
  }
}
